var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOverlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "170px",
    viewBox: "0 0 170 170",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video-Overlay",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-arrow",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "68.0000797 123.25006 119.00004 85 68.0000797 46.7499402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9998008,0 C38.0376031,0 0,38.0376922 0,85 C0,131.962308 38.0376031,170 84.9998008,170 C131.961998,170 170,131.962706 170,85 C170,38.0372938 131.962397,0 84.9998008,0 Z M84.9998008,153.000239 C47.5148301,153.000239 16.9997211,122.485059 16.9997211,85 C16.9997211,47.5149414 47.5148301,17.0001594 84.9998008,17.0001594 C122.484771,17.0001594 152.99988,47.5149414 152.99988,85 C152.99988,122.485059 122.484771,153.000239 84.9998008,153.000239 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOverlay);
export default __webpack_public_path__ + "static/media/Video Overlay.93b913492ad27da98cf10e346cec58df.svg";
export { ForwardRef as ReactComponent };